<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal Header -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="modal-title">Send Password Reset Link</div>
                </div>
                <div class="close-icon">
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div class="font-weight-bold text-center">Are you sure you want to send a password reset link to </div>
                        <div class="username">
                            {{ capitalizeFirstLetter(userInfo.first_name) + ' ' + capitalizeFirstLetter(userInfo.last_name) }}?
                        </div>
                    </div>
                </div>
                <br/>
                <div class="row m-4">
                    <div class="col-6">
                        <button type="button" class="float-left btn btn-sm cancelBtn closeBtn" @click="closeModal">Cancel</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="float-right btn btn-sm sendLinkBtn ma-blue-btn" @click="sendLink">Send Link</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isModalVisible'
    ],
  data() {
    return {
        loading: false,
        userInfo: {},
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    setUserInfo(user) { 
        this.userInfo = user;
    },
    capitalizeFirstLetter(string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    sendLink() {
        axios('/enterprise-admin/forgot_password',
            {
                method: 'POST',
                data: {
                  email_id: this.userInfo.email,
                  account_id: this.userInfo.accountId
                }
            }
        )
        .then((response) => {
            this.$parent.resetLinkSuccessMsg = 'Reset Password Email Sent Successfully';
            this.closeModal();
        })
        .catch(error => {

        });
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 450px;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;  
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #00acee;
  font-size: 1.4rem;
  font-weight: 900;
  text-align: center !important;
}
.modal-header {
  padding: 5px;
  border-bottom: 0px;
  margin-bottom: 10px;
  text-align: center !important;
}
.modal-body {
  padding: 5px;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.cancelBtn, .cancelBtn:focus, .cancelBtn:active, .cancelBtn:hover {
  font-weight: 900;
  width: 150px;
  border-radius: 10px;
}
.sendLinkBtn, .sendLinkBtn:focus, .sendLinkBtn:active, .sendLinkBtn:hover {
  color: #FFF !important;
  min-height: 35px;
  margin-top: -5px;
  border-radius: 10px;
  width: 150px;
}
.username { font-size: 1.25rem; font-weight: 900; text-align: center; margin: 10px 0; }
.close-icon { position: absolute; left: 0; right: 15px; top: 10px }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/loation_reset_modal.vue